import React, { forwardRef } from "react";
import { Box, AppBar, Toolbar, makeStyles, useMediaQuery, } from "@material-ui/core";
import MicroLogo from "../MicroLogo";
const useStyles = makeStyles((theme) => ({
    appbar: ({ secondaryBarBackgroundColor }) => ({
        [theme.breakpoints.only("xs")]: {
            backgroundColor: secondaryBarBackgroundColor
                ? secondaryBarBackgroundColor
                : theme.palette.type === "dark"
                    ? theme.palette.grey[600]
                    : theme.palette.grey[50],
        },
        [theme.breakpoints.up("sm")]: {
            borderBottomColor: "transparent !important",
        },
        backgroundColor: theme.palette.grey[800],
        "& .MuiSvgIcon-root": {
            [theme.breakpoints.only("xs")]: {
                width: 24,
                height: 24,
                fill: theme.palette.type === "dark"
                    ? theme.palette.grey[100]
                    : theme.palette.grey[700],
            },
            fill: theme.palette.grey[100],
        },
        "& .MuiIconButton-root": {
            padding: theme.spacing(1),
        },
    }),
    toolbar: {
        minHeight: 48,
    },
    logo: {
        marginRight: theme.spacing(1),
        "& path": {
            fill: theme.palette.common.white,
        },
    },
    smallLogo: {
        width: 24,
        marginLeft: 4,
    },
    title: {
        [theme.breakpoints.only("xs")]: {
            color: theme.palette.type === "dark"
                ? theme.palette.common.white
                : theme.palette.grey[800],
        },
        color: theme.palette.common.white,
    },
    logoTitle: {
        color: theme.palette.common.white,
    },
    right: {
        marginLeft: "auto",
    },
}));
export const AppHeader = forwardRef(({ title, left = null, right = null, secondaryBarBackgroundColor, ...props }, ref) => {
    const large = useMediaQuery((theme) => theme.breakpoints.up("sm"));
    const classes = useStyles({ secondaryBarBackgroundColor });
    return (React.createElement(Box, { ...props, 
        // @ts-ignore
        ref: ref },
        !large && (React.createElement(StripHeader, null,
            React.createElement(MicroLogo, { className: `${classes.logo} ${classes.smallLogo}` }),
            React.createElement(CoMTitle, { className: classes.logoTitle }, "City of Melbourne"))),
        (large || left || right || title) && (React.createElement(AppBar, { position: "static", className: classes.appbar, elevation: 0 },
            React.createElement(Toolbar, { className: classes.toolbar },
                left,
                large && (React.createElement(React.Fragment, null,
                    React.createElement(MicroLogo, { className: classes.logo }),
                    React.createElement(CoMTitle, null, "City of Melbourne"))),
                React.createElement(CoMTitle, { className: classes.title }, title),
                right && React.createElement("div", { className: classes.right }, right))))));
});
const StripHeader = ({ children }) => {
    return (React.createElement(Box, { display: "flex", alignItems: "center", height: 36, pl: 1, bgcolor: "grey.800" }, children));
};
const CoMTitle = ({ children, ...props }) => {
    return (React.createElement(Box, { component: "span", fontFamily: "CoM", fontSize: { xs: 18, sm: 24 }, position: "relative", top: 3, mr: 2, ...props }, children));
};
